import type { SxProps } from "@mui/material";
import type { ThemeV2 } from "../../../util/types";

export const inputWrapper = (
  isLandScapeMode: boolean,
  theme: ThemeV2,
): SxProps => ({
  width: "100%",
  height: isLandScapeMode ? "max-content" : null,
  backgroundColor: isLandScapeMode
    ? theme.tokens.color.surface.card
    : theme.tokens.color.action.primary,
  padding: {
    md: isLandScapeMode
      ? `${theme.tokens.spacing["3"]}px`
      : `${theme.tokens.spacing["3"]}px 0 ${theme.tokens.spacing["3"]}px ${theme.tokens.spacing["3"]}px`,
    xs: isLandScapeMode
      ? `${theme.tokens.spacing["3"]}px`
      : `${theme.tokens.spacing["4"]}px ${theme.tokens.spacing["2"]}px ${theme.tokens.spacing["4"]}px`,
  },

  borderRadius: isLandScapeMode
    ? `${theme.tokens.shape.radius.lg}px`
    : {
        md: `0px 0px ${theme.tokens.shape.radius.lg}px ${theme.tokens.shape.radius.lg}px`,
        sm: `${theme.tokens.shape.radius.none}px`,
      },
  border: `1px solid ${theme.tokens.color.action.primary}`,
  marginY: 1,
  display: "flex",
  "& > *": {
    flex: isLandScapeMode ? null : "1 1 auto",
    minWidth: 0,
  },
  "& > * + *": {
    ml: 2,
  },
  "& :last-child": {
    flex: "0 1 auto",
  },
  zIndex: 1,
  boxShadow: isLandScapeMode ? theme.tokens.elevation[3] : "",
});

const rankContainerStyles = {
  landscape: {
    justifyContent: "center",
    alignItems: "end",
    flexDirection: "row",
  },
  portrait: {
    justifyContent: "end",
    alignItems: "end",
    flexDirection: "row",
  },
};

export const selectMultiSelectRankContainerStyle = (
  isLandScapeMode: boolean,
) =>
  isLandScapeMode
    ? rankContainerStyles.landscape
    : rankContainerStyles.portrait;

export const choiceGroupHeadingStyle = (
  isLandscapeMode: boolean,
  isList: boolean,
  theme: ThemeV2,
) =>
  ({
    "& > [data-visual-group-heading]": {
      textAlign: isList ? "start" : isLandscapeMode ? "center" : "end",
      paddingInline: isList ? 0 : `${theme.tokens.spacing["1"] / 2}px`,
    },
  }) as const;

export const selectMultiSelectRankBorder = (
  isLandScapeMode: boolean,
  borderColor: string | undefined,
  surfaceColor: string,
  radius: number,
  sx?: SxProps,
) => {
  if (!isLandScapeMode) {
    return {
      ...sx,
      border: `1px solid ${borderColor}`,
      backgroundColor: surfaceColor,
      borderRadius: `${radius}px`,
    };
  }
};
